import antdArEG from 'antd/es/locale/ar_EG';
import arMsg from "../locales/ar_EG.json";

const ArLang = {
  antd: antdArEG,
  locale: 'ar-EG',
  messages: {
    ...arMsg
  },
};
export default ArLang;
